<template>
  <div class="model-provider-select">
    <el-form :model="vModelAddModel" disabled style="width:100%" :rules="rules" ref="form" hide-required-asterisk>
      <el-row justify="end">
        <el-col :span="12">
          <el-form-item prop="model" class="inline-form-item" style="width:100%">
            <template #label>
              <el-tooltip effect="dark" content="模型就像是智能体的大脑，不同的模型会让智能体有不同的能力和表现。" placement="top-start">
                <span>
                  <span>模型</span>
                  <el-icon style="margin-left: 3px;">
                    <QuestionFilled />
                  </el-icon>
                </span>
              </el-tooltip>
            </template>
            <el-select-v2 v-model="vModelAddModel.model" :options="bigModelList" placeholder="请选择模型"
              @change="modelChange">
              <template #header>
                <el-input v-model="search" placeholder="搜索您所需的模型" :prefix-icon="Search" />
              </template>
              <template #prefix>
                <i class="ri-brain-fill" style="margin-right: 5px;color: #a3c7ff;"></i>
              </template>
              <template #default="{ item }">
                <i class="ri-brain-fill" style="margin-right: 5px;color: #a3c7ff;"></i>
                <span style="font-weight: bold">{{ item.label }}</span>
              </template>
            </el-select-v2>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script setup>
import { Search } from '@element-plus/icons-vue'
import { reactive, ref, computed, watch, onMounted } from 'vue';
import { appProjectGetModel, appProjectGetModelProvider } from '@/request/appProject';

const emits = defineEmits(['update:addModel']);
const props = defineProps({
  addModel: {
    type: Object,
    default: () => ({}),
  },
});

const vModelAddModel = computed({
  get: () => props.addModel,
  set: (val) => emits('update:addModel', val),
});

const form = ref(null);
const bigModelList = ref([]);
const originalBigModelList = ref([]);
const rules = reactive({});

const getAppProjectGetModel = async () => {
  const res = await appProjectGetModel();
  const { code, data } = res.data;
  if (code !== 200) return;
  const processedData = data.data.map((item) => {
    const { zh_Hans: providerLabel } = item.label;
    return {
      value: item.provider,
      label: providerLabel,
      config: item,
      options: item.models?.map((i) => {
        const { zh_Hans } = i.label;
        return {
          ...i,
          label: zh_Hans,
          value: i.model,
          providerLabel: providerLabel,
        };
      }),
    };
  });
  bigModelList.value = processedData;
  originalBigModelList.value = processedData;

  // 检查并设置默认模型
  if (!vModelAddModel.value.model && bigModelList.value.length > 0 && bigModelList.value[0].options.length > 0) {
    vModelAddModel.value.model = bigModelList.value[0].options[0].value;
    modelChange(vModelAddModel.value.model);
  }
};

getAppProjectGetModel();

watch(() => vModelAddModel.value.model, (newVal) => {
  if (!newVal && bigModelList.value.length > 0 && bigModelList.value[0].options.length > 0) {
    vModelAddModel.value.model = bigModelList.value[0].options[0].value;
    modelChange(vModelAddModel.value.model);
  }
});

// 选中大模型
let modelChange = (selectedValue) => {
  const selectedModel = bigModelList.value.find(({ options }) =>
    options.find(v => v.value === selectedValue)
  );
  vModelAddModel.value.provider = selectedModel.value
  vModelAddModel.value.completionParams = {}


  // 获取模型配置暂时不使用
  // let modelDetailArr = await getModelDetailFn(vModelAddModel.value.provider, selectedValue)
}


const getModelDetailFn = (provider, model) => {
  return appProjectGetModelProvider({ provider, model })
    .then((res) => {
      let { data, code } = res.data
      if (code === 200) {
        return data.data
      }
      return []
    })
    .catch((error) => {
      // 处理错误或返回一个错误标记
      return [];
    });
};

// 查询
let search = ref('')
watch(search, (newSearchTerm) => {
  bigModelList.value = originalBigModelList.value.filter((item) => {
    return item.options.some((option) =>
      option.label.includes(newSearchTerm)
    );
  });
});
</script>

<style scoped lang="scss">
.model-provider-select {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.inline-form-item {
  margin-bottom: 0;
}

.el-form-item__label {
  font-weight: bold;
  color: #fff;
}

.el-select {
  width: 100%;
}

.el-form-item {
  margin-right: 10px;
}
</style>